import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import ST10030View from "../../Views/Stock/ST10030";
import Snackbar from "../../Components/Snackbar";
import { Landscape } from "@mui/icons-material";

function ST10030(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [rowData, setRowData] = React.useState([]);
  const [itemType, setItemType] = React.useState([
    {
      plantCd: "",
      itemType: "",
    },
  ]);
  const [checkInputs1, setCheckInputs1] = React.useState({
    value1: "",
    value2: "",
    value3: "",
    itemType: "",
  });
  const [checkInputs2, setCheckInputs2] = React.useState({
    value1: "",
    value2: "",
    value3: "",
    whCd: "WH_MM_03",
    whFromCd: "WH_MM_03",
    moveWhCd: "WH_MM_01",
  });
  // 품목타입 콤보박스
  const [whType, setWhType] = React.useState([]); //창고타입 콤보박스
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [stockData, setStockData] = React.useState([]);
  const [authGroupGridRowData1, setAuthGroupGridRowData1] = React.useState([]);
  const [lanData, setLanData] = React.useState([]);

  const [checkInputs, setCheckInputs] = React.useState({
    itemCd: "",
    itemNm: "",
    whCd: "WH_IN_01",
    itemQty: 0,
    plantCd: "P100",
    comboList: [],
    comboInwh: [], //창고
    comboWhCd: [], //재고이동 안 창고
    comboMoveWhCd: [], //재고이동 안 이동창고
  });
  const [userInfo, setUserInfo] = React.useState([]);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 1)
  );
  let selectedPoNo = "";
  const [endDate, setEndDate] = React.useState(new Date());
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    CmItemType();
    SearchLogic();
  }, []);

  const StockHelper = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    try {
      if (!checkInputs.itemCd) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_ ChoseItem" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      } else if (!checkInputs.whCd) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_ ChoseWh" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      }
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10030.Create,
        {
          createId: userInfo.userId,
          itemCd: checkInputs.itemCd,
          itemQty: checkInputs.itemQty,
          whCd: checkInputs.whCd,
          plantCd: checkInputs.plantCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          throw new Error(data.message);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          CmItemType();
          SearchLogic();
          setCheckInputs({
            ...checkInputs,
            itemCd: "",
            itemQty: 0,
            itemType: "",
            plnatCd: "",
          });
          setSnackbars({
            toggle: true,
            type: "success",
            message: "저장되었습니다.",
          });
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };
  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        setUserInfo(result);
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10030.GetStockList,
        {
          StartDate: new Date(startDate),
          endDate: endDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              custNm: data[i].custNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              itemFormula: data[i].itemFormula,
              soItemAmt: data[i].stockQty * data[i].itemStdAmt,
              lCatego: data[i].lCatego,
              mCatego: data[i].mCatego,
              sCatego: data[i].sCatego,
              itemType: data[i].itemType,
              lotNo: data[i].lotNo,
              whCd: data[i].whCd,
              whNm: data[i].whNm,
              itemUnit: data[i].itemUnit,
              itemGroup: data[i].itemGroup,
              itemCatego: data[i].itemCatego,
              projectNm: data[i].projectNm,
              personCharg: data[i].personCharg,
              remark: data[i].remark,
              itemStdAmt:
                data[i].itemVatYn === "N"
                  ? data[i].itemStdAmt
                  : data[i].itemStdAmt * 1.1,
              stockQty: parseFloat(data[i].stockQty),
              stockAddQty: parseFloat(
                Commons.splitReserveFun(
                  data[i].stockQty,
                  data[i].itemFormula ? data[i].itemFormula : 1
                )
              ),
              stockTakingDt: data[i].stockTakingDt
                ? Commons.DateFormating(data[i].stockTakingDt.toString(), 2)
                : "",
              manuFacDt: data[i].manuFacDt
                ? Commons.DateFormating(data[i].manuFacDt.toString(), 2)
                : "",
              doYn: data[i].doYn,
              createDate: data[i].createDate
                ? Commons.DateFormating(data[i].createDate.toString(), 2)
                : "",
              createId: data[i].createId,
              updateDate: data[i].updateDate
                ? Commons.DateFormating(data[i].updateDate.toString(), 2)
                : "",
              updateId: data[i].updateId,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const GetCommonItemList = async (_value) => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList2,
        {
          custCd: "string",
          plantCd: "string",
          itemType:
            checkInputs1.itemType === "" ? "string" : checkInputs1.itemType,
          value: _value === "" ? "string" : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
          setAuthGroupGridRowData1([]);
        } else {
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              itemUnit: data[i].itemUnit,
              itemUnitNm: data[i].itemUnitNm,
              itemStdAmt: data[i].itemStdAmt,
              poItemCost: data[i].poItemCost,
              itemVatYn: data[i].itemVatYn,
              itemFormula: data[i].itemFormula,
              itemTypeNm: data[i].itemTypeNm,
              whNm: data[i].whNm,
            });
          }
          setAuthGroupGridRowData1(getData);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //재고이동(조회)
  const GetMoveStockData = async (_value, _whCd) => {
    Dialog.ProgressBar(true);
    let getData = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Stock.ST10030.GetMoveStockList,
        {
          whCd: _whCd,
          value: _value == "" ? "string" : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
          setStockData([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              lotNo: data[i].lotNo,
              itemNm: data[i].itemNm,
              itemCd: data[i].itemCd,
              stockQty: data[i].stockQty,
              whCd: data[i].whCd,
            });
          }
          getData = getData.filter((e) => e.stockQty > 0);
          setStockData(getData);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //재고이동알림
  const SaveConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) =>
          f.lanId === "Dia_Title_TransferInventory" && f.lanType === "DIALOG"
      )[0].lanName,
      // `관리자: ${userInfo.userId}
      `
        ${
          lanData.filter(
            (f) =>
              f.lanId === "Dia_Message_MoveInventory" && f.lanType === "DIALOG"
          )[0].lanName
        }
      `,

      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        MoveWhCdStock(_type);
      }
    );
  };
  //재고이동
  const MoveWhCdStock = async (_moveData) => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let postData = [];
    try {
      // for (let i = 0; i < _moveData.length; i++) {
      //   _moveData[i].whCd = checkInputs2.moveWhCd;
      // }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Stock.ST10030.UpdateMoveStock,
        { whFromCd: checkInputs2.moveWhCd },
        _moveData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        } else {
          SearchLogic();
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const CmItemType = async (_custCd = "") => {
    Dialog.ProgressBar(true);
    let getComboData = [];
    let getComboData1 = [];
    let getComboData2 = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList,
        {
          plantCd: "string",
          value: "string",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.type === "데이터가 없습니다.") {
          throw new Error(data.message);
        } else {
          for (let i = 0; i < data.length; i++) {
            getComboData1.push({
              plantCd: data[i].plantCd,
              name: data[i].itemNm,
              value: data[i].itemCd,
            });
          }
          setItemType(Commons.InsertNumber(getComboData1));
        }
      });
      //창고코드 콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh,
        {
          whCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData2.push({
            value: data[i].value,
            name: data[i].name,
          });
        }
        checkInputs.comboWhCd = getComboData2.filter(
          (e) => e.value.substring(0, 5) == "WH_MM"
        );
        checkInputs.comboMoveWhCd = getComboData2.filter(
          (e) => e.value.substring(0, 5) == "WH_MM"
        );
        setWhType(getComboData2);
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.type === "데이터가 없습니다.") {
          throw new Error(data.message);
        } else {
          for (let i = 0; i < data.length; i++) {
            getComboData.push({
              groupCd: data[i].GroupCd,
              name: data[i].Name,
              value: data[i].Code,
            });
          }

          checkInputs.comboList = getComboData.filter(
            (e) => e.groupCd == "ITEM_TYPE"
          );

          checkInputs.comboInwh = getComboData.filter(
            (e) => e.groupCd == "WH_CD"
          );
          // setWhType(Commons.InsertNumber(checkInputs.comboInwh));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <>
      <ST10030View
        rowData={rowData}
        setRowData={setRowData}
        itemType={itemType}
        setItemType={setItemType}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        CmItemType={CmItemType}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        SearchLogic={SearchLogic}
        setAuthGroupGridRowData1={setAuthGroupGridRowData1}
        authGroupGridRowData1={authGroupGridRowData1}
        StockHelper={StockHelper}
        startDate={startDate}
        setStartDate={setStartDate}
        checkInputs1={checkInputs1}
        stockData={stockData}
        MoveWhCdStock={MoveWhCdStock}
        setStockData={setStockData}
        GetMoveStockData={GetMoveStockData}
        setCheckInputs1={setCheckInputs1}
        checkInputs2={checkInputs2}
        setCheckInputs2={setCheckInputs2}
        whType={whType}
        GetCommonItemList={GetCommonItemList}
        lanData={lanData}
        SaveConfirm={SaveConfirm}
        endDate={endDate}
        setEndDate={setEndDate}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default ST10030;
